import { render, staticRenderFns } from "./certMessage.vue?vue&type=template&id=5dcba8af"
import script from "./certMessage.vue?vue&type=script&lang=js"
export * from "./certMessage.vue?vue&type=script&lang=js"
import style0 from "./certMessage.vue?vue&type=style&index=0&id=5dcba8af&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports